
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { HeightChart } from "./HeightChart";
import { WeightChart } from "./WeightChart";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { NoGrowthDataMessage } from "./NoGrowthDataMessage";

interface GrowthTabsProps {
  heightData: any[];
  weightData: any[];
  displayOriginalHeight: number | null;
  displayOriginalWeight: number | null;
  useMetricHeight: boolean;
  useMetricWeight: boolean;
  handleHeightUnitToggle: () => void;
  handleWeightUnitToggle: () => void;
  babyAgeInMonths: number;
}

export function GrowthTabs({
  heightData,
  weightData,
  displayOriginalHeight,
  displayOriginalWeight,
  useMetricHeight,
  useMetricWeight,
  handleHeightUnitToggle,
  handleWeightUnitToggle,
  babyAgeInMonths
}: GrowthTabsProps) {
  const { language } = useLanguage();
  
  return (
    <>
      <Tabs defaultValue="height" className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2 mb-6">
          <TabsTrigger value="height">{t('statistics.height', language)}</TabsTrigger>
          <TabsTrigger value="weight">{t('statistics.weight', language)}</TabsTrigger>
        </TabsList>
        
        <TabsContent value="height">
          <HeightChart 
            heightData={heightData}
            displayOriginalHeight={displayOriginalHeight}
            useMetricHeight={useMetricHeight}
            handleHeightUnitToggle={handleHeightUnitToggle}
            babyAgeInMonths={babyAgeInMonths}
          />
        </TabsContent>
        
        <TabsContent value="weight">
          <WeightChart 
            weightData={weightData}
            displayOriginalWeight={displayOriginalWeight}
            useMetricWeight={useMetricWeight}
            handleWeightUnitToggle={handleWeightUnitToggle}
            babyAgeInMonths={babyAgeInMonths}
          />
        </TabsContent>
      </Tabs>
      
      <NoGrowthDataMessage heightData={heightData} weightData={weightData} />
    </>
  );
}

